import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { createSSEConnection } from "@/api/sync";
import { useAuthStore } from "@/store/authStore";
import type { ChangeEvent } from "@/api/types";

export function useSync() {
  const queryClient = useQueryClient();
  const accessToken = useAuthStore((state) => state.accessToken);

  useEffect(() => {
    if (!accessToken) {
      return undefined;
    }

    const eventSource = createSSEConnection(accessToken);

    eventSource.onmessage = (event) => {
      const payload = JSON.parse(event.data) as ChangeEvent;

      if (payload.entity_type === "file") {
        void queryClient.invalidateQueries({ queryKey: ["files"] });
        void queryClient.invalidateQueries({ queryKey: ["file", payload.entity_id] });
      }
      if (payload.entity_type === "folder") {
        void queryClient.invalidateQueries({ queryKey: ["folders"] });
      }
      if (payload.entity_type === "share") {
        void queryClient.invalidateQueries({ queryKey: ["shares"] });
      }
      void queryClient.invalidateQueries({ queryKey: ["activity"] });
    };

    eventSource.onerror = () => {
      console.warn("seaDrive SSE disconnected; EventSource will retry automatically.");
    };

    return () => eventSource.close();
  }, [accessToken, queryClient]);
}
